<div class="modal-container" (click)="closeAllDropdowns()" *transloco="let t; prefix: 'workOrder'">
  <div class="modal-container__header">
    <span class="modal-container__header-title">{{ t('modals.create.title') }}</span>
    <button
      class="modal-container__header-btn"
      (click)="closeModal()"
      [title]="'common.close' | transloco">
      <svg
        class="modal-container__header-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z"
          fill="#9FA1A4" />
      </svg>
    </button>
  </div>

  <div class="modal-container__body">
    <div class="modal-form">
      <app-asset-search-dropdown
        [accountIds]="[]"
        [selectedAssetId]="formData.assetId"
        [selectedAssetName]="selectedAsset?.assetName ?? ''"
        [showRequiredError]="touched.asset && formData.assetId <= 0"
        (assetSelected)="onAssetSelect($event)">
      </app-asset-search-dropdown>

      <div class="modal-form__field" (click)="$event.stopPropagation()">
        <label class="modal-label">{{ t('modals.shared.serviceType') }} <span class="required">*</span></label>
        <div class="dropdown-input-wrapper" (click)="toggleServiceTypeDropdown()">
          <input
            class="modal-input"
            type="text"
            [placeholder]="selectedServiceTypeName || t('modals.shared.selectServiceType')"
            [value]="selectedServiceTypeName"
            readonly />
          <svg
            class="dropdown-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z"
              fill="#9FA1A4" />
          </svg>
        </div>
        @if (serviceTypeDropdownOpen) {
          <ul class="modal-dropdown-menu">
            @for (type of serviceTypes; track type.id) {
              <li (click)="selectServiceType(type)">{{ type.name | transloco }}</li>
            }
          </ul>
        }
        @if (touched.serviceType && formData.serviceType <= 0) {
          <div class="error-message">{{ t('modals.create.serviceTypeRequired') }}</div>
        }
      </div>

      <div class="modal-form__field" (click)="$event.stopPropagation()">
        <app-flatpickr-date-picker
          [label]="t('modals.create.scheduleADate')"
          [value]="scheduledDateValue"
          (valueChange)="onScheduledDateChange($event)"
          [minDate]="'today'"
          [dateFormat]="'Y-m-d H:i'"
          [altFormat]="'d/m/Y H:i'"
          [placeholder]="t('modals.shared.dateTimePlaceholder')"
          [enableTime]="true"
          [time24hr]="true"
          [required]="true">
        </app-flatpickr-date-picker>
        @if (touched.scheduledDate && !hasValidScheduledDate) {
          <div class="error-message">{{ t('modals.shared.scheduledDateRequired') }}</div>
        }
      </div>

      <div class="modal-form__field" (click)="$event.stopPropagation()">
        <label class="modal-label">{{ t('modals.shared.maintenanceReason') }} <span class="required">*</span></label>
        <div class="dropdown-input-wrapper" (click)="toggleMaintenanceReasonDropdown()">
          <input
            class="modal-input"
            type="text"
            [placeholder]="selectedMaintenanceReasonName || t('modals.create.selectReason')"
            [value]="selectedMaintenanceReasonName"
            readonly />
          <svg
            class="dropdown-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z"
              fill="#9FA1A4" />
          </svg>
        </div>
        @if (maintenanceReasonDropdownOpen) {
          <ul class="modal-dropdown-menu">
            @if (isLoadingReasons) {
              <li>{{ t('modals.create.loadingReasons') }}</li>
            } @else if (maintenanceReasons.length === 0) {
              <li>{{ t('modals.create.noReasonsFound') }}</li>
            } @else {
              @for (reason of maintenanceReasons; track reason.id) {
                <li (click)="selectMaintenanceReason(reason)">
                  {{ reason.localizedName || reason.name }}
                </li>
              }
            }
          </ul>
        }
        @if (touched.maintenanceReason && formData.maintenanceReasonId <= 0) {
          <div class="error-message">{{ t('modals.create.maintenanceReasonRequired') }}</div>
        }
      </div>

      <div class="modal-form__field" (click)="$event.stopPropagation()">
        <label class="modal-label">{{ t('modals.create.assignAssetWorkshop') }} <span class="required">*</span></label>
        <div
          class="dropdown-input-wrapper"
          [class.disabled]="isWorkshopDisabled"
          (click)="toggleWorkshopDropdown()">
          <input
            class="modal-input"
            type="text"
            [placeholder]="formData.assetId <= 0 ? t('modals.create.selectAssetFirst') : selectedWorkshopName || t('modals.shared.selectWorkshop')"
            [value]="selectedWorkshopName"
            [disabled]="isWorkshopDisabled"
            readonly />
          <svg
            class="dropdown-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.862 6.19534L7.99998 9.05734L5.13798 6.19534L4.19531 7.13801L7.99998 10.9427L11.8046 7.13801L10.862 6.19534Z"
              fill="#9FA1A4" />
          </svg>
        </div>
        @if (workshopDropdownOpen) {
          <ul class="modal-dropdown-menu">
            @if (isLoadingWorkshops) {
              <li>{{ t('modals.create.loadingWorkshops') }}</li>
            } @else if (workshops.length === 0) {
              <li>{{ t('modals.create.noWorkshopsFound') }}</li>
            } @else {
              @for (workshop of workshops; track workshop.id) {
                <li (click)="selectWorkshop(workshop)">
                  {{ workshop.name }}
                </li>
              }
            }
          </ul>
        }
        @if (touched.workshop && formData.workshopId <= 0) {
          <div class="error-message">{{ t('modals.create.workshopRequired') }}</div>
        }
      </div>

      <div class="modal-form__field">
        <label class="modal-label">{{ t('modals.create.additionalComments') }}</label>
        <textarea
          class="modal-textarea"
          [(ngModel)]="formData.notes"
          [placeholder]="t('modals.create.commentsPlaceholder')"></textarea>
      </div>

      <div class="modal-form__row">
        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.estimatedCost') }}</label>
          <div class="input-with-prefix">
            <span class="input-prefix">{{ currencySymbol }}</span>
            <input
              class="modal-input"
              type="number"
              [(ngModel)]="formData.estimatedCost"
              placeholder="0" />
          </div>
        </div>

        <div class="modal-form__field modal-form__field--half">
          <label class="modal-label">{{ t('modals.shared.estimatedTime') }}</label>
          <div class="input-with-suffix">
            <input
              class="modal-input"
              type="number"
              [(ngModel)]="formData.estimatedTime"
              (ngModelChange)="onEstimatedTimeInputChange()"
              placeholder="0" />
            <span class="input-suffix" [style.left.px]="timeSuffixLeft">{{ t('modals.shared.hours') }}</span>
          </div>
        </div>
      </div>

      <div class="modal-form__alert-section">
        <label class="modal-label">{{ t('modals.shared.alertNotification') }}</label>
        <div class="modal-form__alert-toggle">
          <div class="alert-toggle-content">
            <span class="alert-toggle-title">{{ t('modals.shared.enableEmailAlerts') }}</span>
            <span class="alert-toggle-description">{{ t('modals.shared.emailAlertDescription') }}</span>
          </div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="formData.enableEmailAlert" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="modal-actions">
        <button class="modal-btn cancel" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
        <button
          class="modal-btn create"
          [disabled]="!isFormValid || isLoading"
          (click)="createWorkOrder()">
          @if (isLoading) {
            <span class="spinner-border"></span>
          } @else {
            <span>{{ t('modals.create.submit') }}</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>